module.exports = __webpack_public_path__ + "img/moneygun1.db76febf.png";